import request from '@/src/apis/axios';
import {
  DeleteEntryByIdRequestBody,
  GetEntriesRequestParams,
  GetEntryParticipantsRequestParams,
  PostEntryRequestBody,
  PutEntryRequestBody,
} from '@/src/apis/rest/entry.dtos';
import EntryDto from '@/src/models/EntryDto';
import EntryParticipantsDto from '@/src/models/EntryParticipantDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';

const URL = {
  entry: '/admin/entries',
  entryDetail: '/admin/entries/{id}',
  entryParticipants: '/admin/entry-participants',
  entryParticipantsExcel: '/admin/entry-participants/excel-export',
  entriesExcel: '/admin/entries/excel/export',
};
// 응모하기 리스트 조회
export const getEntriesAPI = async (
  queryParams: Partial<GetEntriesRequestParams>,
) => {
  const { data } = await request<ListResponse<EntryDto>>({
    method: 'get',
    url: URL.entry,
    queryParams,
  });

  const rows = plainToInstance(EntryDto, data.rows);

  return { rows, count: data.count };
};
// 응모하기 상세 조회
export const getEntryByIdAPI = async (id: number) => {
  const { data } = await request<ObjectResponse<EntryDto>>({
    method: 'get',
    url: URL.entryDetail.replace('{id}', String(id)),
  });

  return plainToInstance(EntryDto, data.row);
};

// 응모하기 생성
export const postEntryAPI = async (requestBody: PostEntryRequestBody) => {
  const { data } = await request<ObjectResponse<EntryDto>>({
    method: 'post',
    url: URL.entry,
    requestBody: { ...requestBody },
  });

  return plainToInstance(EntryDto, data.row);
};
// 응모하기 수정
export const putEntryAPI = async (requestBody: PutEntryRequestBody) => {
  const { id, ...rest } = requestBody;

  const { data } = await request<ObjectResponse<EntryDto>>({
    method: 'put',
    url: URL.entryDetail.replace('{id}', String(id)),
    requestBody: { ...rest },
  });

  return plainToInstance(EntryDto, data.row);
};
// 응모하기 삭제
export const deleteEntryByIdAPI = async ({
  id,
}: DeleteEntryByIdRequestBody) => {
  const { data } = await request<ObjectResponse<EntryDto>>({
    method: 'delete',
    url: URL.entryDetail.replace('{id}', String(id)),
  });

  return plainToInstance(EntryDto, data.row);
};

// 응모하기 참여 회원 리스트 조회
export const getEntryParticipantsAPI = async (
  requestParams: Partial<GetEntryParticipantsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<EntryParticipantsDto>>({
    method: 'get',
    url: URL.entryParticipants,
    queryParams: { page, pageSize, ...rest },
  });

  const rows = plainToInstance(EntryParticipantsDto, data.rows);

  return { rows, count: data.count };
};

// 응모하기 참여 회원 리스트 엑셀 다운로드
export const getEntryParticipantsExcelAPI = async (
  password: string,
  requestParams: Partial<GetEntryParticipantsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.entryParticipantsExcel,
    queryParams: { password, ...requestParams },
    config: { responseType: 'blob' },
  });

  return data;
};

export const getEntriesExcelAPI = async (
  password: string,
  requestParams: Partial<GetEntriesRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.entriesExcel,
    queryParams: { password, ...requestParams },
    config: { responseType: 'blob' },
  });

  return data;
};
